import { Controller } from "@hotwired/stimulus"

// Counts down on the fail-open interstitial, then clicks the sign-in button, so
// the user sees why sign-in is continuing before it does. Clicking it sooner
// works too; a disabled (already clicked) button ignores the late click.
export default class extends Controller {
  static targets = ["button", "countdown"]
  static values = {
    seconds: Number
  }

  connect() {
    this.remaining = this.secondsValue
    this.showRemaining()
    this.timer = setInterval(() => this.tick(), 1000)
  }

  disconnect() {
    clearInterval(this.timer)
  }

  tick() {
    this.remaining -= 1
    this.showRemaining()
    if (this.remaining > 0) return

    clearInterval(this.timer)
    if (this.hasButtonTarget) this.buttonTarget.click()
  }

  showRemaining() {
    this.countdownTargets.forEach((target) => {
      target.textContent = Math.max(this.remaining, 0)
    })
  }
}
